var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTriangleVectors(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 181,
    viewBox: "0 0 166 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.02 35.2912L108.315 9.8256L130.341 16.0397L113.02 35.2912Z",
    fill: "#F3DDC4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M156.584 145.895L145.338 169.223L131.235 151.197L156.584 145.895Z",
    fill: "#F3DDC4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9268 172.523L50.8082 156.217L71.5922 146.634L70.9268 172.523Z",
    fill: "#F3DDC4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3204 99.4877L106.84 78.7568L117.215 99.1567L91.3204 99.4877Z",
    fill: "#F3DDC4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1446 102.323L11.2508 101.94L21.6664 81.5605L37.1446 102.323Z",
    fill: "#F3DDC4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleVectors);
export default __webpack_public_path__ + "static/media/triangle_vectors.2346ca14c631704351eab2ce91ebda67.svg";
export { ForwardRef as ReactComponent };